import * as React from "react";
import levelsData from "../data/levelsData.json";
import * as levels from "../styles/levels.module.scss";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabUnstyled from "@mui/base/TabUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";

export const Levels = ({ data= {levelsData} }) => {

  const [active, setActive] = React.useState(0);

  return (
    <section className={levels.levels}>
      <div className="container">
        <h2 className={levels.levels__title}>4 уровня, которые идут внахлёст</h2>
        <p className={levels.levels__text}>
          Даже если у вас пробелы в предыдущих уровнях, платформа сделана так, что все пробелы закрываются
        </p>

        <TabsUnstyled defaultValue={0} selectionFollowsFocus className={levels.levels__wrapper}>
          <TabsListUnstyled className={levels.levels__buttons}>
            {levelsData.map((elem, index) => (
              <TabUnstyled className={`${active === elem.id ? `${levels.levels__button_active}` : `${levels.levels__button_hidden}`}`} key={index} onClick={()=>{setActive(elem.id)}}>
                {
                  <>
                    <span className={levels.num}>{elem.levelSymbol}</span>
                    <br />
                    <span className={levels.desc}>{elem.levelName}</span>
                  </>
                }
              </TabUnstyled>
            ))}
          </TabsListUnstyled>
          {levelsData.map((elem, index) => (
            <TabPanelUnstyled key={index} value={elem.id} className={levels.levels__tabPanel}>
              {
                <div className={levels.levels__info}>
                  <ul className={levels.levels__info_abilities}>
                    {elem.description.abilities.map((elem, index) => (
                      <li key={index}>{elem}</li>
                    ))}
                  </ul>
                  <ul className={levels.levels__info_materials}>
                    {elem.description.materials.map((elem, index) => (
                      <li key={index}>{elem}</li>
                    ))}
                  </ul>
                </div>
              }
            </TabPanelUnstyled>
          ))}
        </TabsUnstyled>

        <p className={levels.levels__text}>
          Помимо изучения английского, в курс включены упражнения для развития памяти и внимания. Программа курса
          соответствует международным стандартам и включает все лексические и грамматические темы, которые проходятся на
          каждом из уровней.
        </p>
      </div>
    </section>
  );
};
